<template>
  <q-select
    ref="fieldMultiselectRef"
    class="san-field san-field--multiselect"
    popup-content-class="san-field--multiselect--popup"
    outlined
    :color="color"
    dropdown-icon="mono-chevron-down"
    input-class="ellipsis"
    no-error-icon
    emit-value
    map-options
    options-dense
    multiple
    use-chips
    use-input
    popup-no-route-dismiss
    :stack-label="$attrs.dense"
  >
    <template #selected-item="scope">
      <q-chip
        icon-remove="mono-cross-circle-solid"
        dense
        removable
        @remove="scope.removeAtIndex(scope.index)"
      >
        {{ scope.opt[$attrs['option-label']] }}
      </q-chip>
    </template>

    <template
      v-for="(slot, slotName) in $slots"
      #[slotName]="scope"
      :key="slotName"
    >
      <slot
        :name="slotName"
        v-bind="scope || {}"
      />
    </template>
  </q-select>
</template>

<script setup>

import { ref } from 'vue'

defineOptions({ name: 'SanFieldMultiselect' })
const props = defineProps({
  color: { type: String, default: 'primary-mid' }
})

const fieldMultiselectRef = ref(null)

defineExpose({ fieldMultiselectRef })
</script>
